import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { Form, notification, Button, InputNumber, Switch, Upload, Icon, Select, Input } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../i18n/adminI18n';
import MainContainer from '../../components/MainContainer';
import Format from '../../utils/format';
import ApiCaller from '../../utils/api-caller';

const { Option } = Select;

@inject(
  'loginStore',
  'CmsMenuStore'
)
@observer
class CmsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadingIconImage: false,
      uploadingBannerImage: false
    }
  }

  componentDidMount() {
    this.props.loginStore.authenticateAdmin().then(response => {
      if (!response) {
        this.props.history.push('/admin/login');
      }
    });

    this.props.CmsMenuStore.getData();
  }

  update = () => {
    const { t } = this.props;
    this.props.CmsMenuStore.update().then(resp => {
      if (!resp.isError) {
        this.props.CmsMenuStore.getData();
        notification['success']({
          message: t('Success'),
          description: t('Menu is successfully updated.'),
          duration: 1
        });
      } else {
        notification['error']({
          message: t('Failed'),
          description: resp.error,
          duration: 5
        });
      }
    });
  }

  enabled = (id) => {
    const { t } = this.props;
    this.props.CmsMenuStore.enabledMenu(id).then(resp => {
      if (!resp.isError) {
        this.props.CmsMenuStore.getData();
        notification['success']({
          message: t('Success'),
          description: t('Menu is successfully enabled.'),
          duration: 1
        });
      }
    });
  }

  disabled = (id) => {
    const { t } = this.props;
    this.props.CmsMenuStore.disabledMenu(id).then(resp => {
      if (!resp.isError) {
        this.props.CmsMenuStore.getData();
        notification['success']({
          message: t('Success'),
          description: t('Menu is successfully disabled.'),
          duration: 1
        });
      }
    });
  }

  // UPLOAD Settings

  dummyIconRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok')
    }, 0);
  }

  beforeUploadIconImage = (file) => {
    const { t } = this.props;
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
    if (!isJpgOrPng) {
      notification.warning({
        message: t('Failed to upload image'),
        description: t('You can only upload JPG/PNG file!'),
        placement: 'bottomRight',
      });
    }

    const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
    if (!isLessThan10Mb) {
      notification.warning({
        message: t('Failed to upload image'),
        description: t('Image must smaller or equal to 1MB!'),
        placement: 'bottomRight',
      });
    }

    if (isJpgOrPng && isLessThan10Mb) {
      this.setState({ uploadingIconImage: true });
    }

    return isJpgOrPng && isLessThan10Mb;
  }

  uploadChangeIconImage = (info, title) => {
    if (info.file.status) {
      if (info.file.status === 'uploading') {
        this.props.CmsMenuStore.setimageUrl('');
        return;
      }
      if (info.file.status === 'done') {
        const category = 'CmsImage'
        const titleName = Format.RemoveSpecialChars(title) || 'Default'

        return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(resp => {
          this.props.CmsMenuStore.setimageUrl(resp.imageUrl);
          this.setState({ uploadingIconImage: false });
        });
      }
    }
  }

  dummyBannerRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok')
    }, 0);
  }

  beforeUploadBannerImage = (file) => {
    const { t } = this.props;
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
    if (!isJpgOrPng) {
      notification.warning({
        message: t('Failed to upload banner'),
        description: t('You can only upload JPG/PNG file!'),
        placement: 'bottomRight',
      });
    }

    const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
    if (!isLessThan10Mb) {
      notification.warning({
        message: t('Failed to upload banner'),
        description: t('Image must smaller or equal to 1MB!'),
        placement: 'bottomRight',
      });
    }

    if (isJpgOrPng && isLessThan10Mb) {
      this.setState({ uploadingBannerImage: true });
    }

    return isJpgOrPng && isLessThan10Mb;
  }

  uploadChangeBannerImage = (info, title) => {
    if (info.file.status) {
      if (info.file.status === 'uploading') {
        this.props.CmsMenuStore.setbannerUrl('');
        return;
      }
      if (info.file.status === 'done') {
        const category = 'CmsImage'
        const titleName = Format.RemoveSpecialChars(title) || 'Default'

        return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(resp => {
          this.props.CmsMenuStore.setbannerUrl(resp.imageUrl);
          this.setState({ uploadingBannerImage: false });
        });
      }
    }
  }

  render() {
    const { t } = this.props;
    const {
      data,
      selectedData,
      menuTypes
    } = this.props.CmsMenuStore;

    return (
      <MainContainer title={t('Customize Menu')} menukey='cms-menu'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Form.Item>
              <div className='stm-display-flex
                                            stm-width-100-percent
                                            stm-background-white-three
                                            stm-font-size-14
                                            stm-line-height-18
                                            stm-font-weight-bold
                                            stm-color-495057
                                            stm-border-bottom-width-2
                                            stm-border-bottom-color-white-two
                                            stm-border-bottom-style-solid'>
                <div className='stm-width-5-percent stm-padding-8'>#</div>
                <div className='stm-width-15-percent stm-padding-8'>{t('Module')}</div>
                <div className='stm-width-5-percent stm-padding-8'>{t('Icon')}</div>
                <div className='stm-width-20-percent stm-padding-8'>{t('Menu')}</div>
                <div className='stm-width-10-percent stm-padding-8'>{t('SP Task ID')}</div>
                <div className='stm-width-10-percent stm-padding-8'>{t('Available')}</div>
                <div className='stm-width-10-percent stm-padding-8'>{t('Hide (Soon)')}</div>
                <div className='stm-width-10-percent stm-padding-8'>{t('Sort')}</div>
                <div className='stm-width-15-percent stm-padding-8'>{t('Action')}</div>
              </div>
              <>
                {
                  data.map(item => {
                    return (
                      <>
                        <div
                          key={item.taskId}
                          className='stm-display-flex 
                                      stm-width-100-percent 
                                      stm-font-size-14 
                                      stm-line-height-18 
                                      stm-border-top-width-1 
                                      stm-border-top-color-white-two 
                                      stm-border-top-style-solid'
                          style={{
                            background: item.isShown ? '#FFFFFF' : '#6C757D',
                            color: item.isShown ? '#495057' : '#FFFFFF'
                          }}>
                          <div className='stm-width-5-percent stm-padding-8'>{item.taskID}</div>
                          <div className='stm-width-15-percent stm-padding-8'>{item.menuType}</div>
                          <div className='stm-width-5-percent stm-padding-8'>
                            {
                              !item.imageUrl || item.imageUrl === ''
                                ?
                                t('No Icon')
                                :
                                <img
                                  src={item.imageUrl}
                                  alt='imageUrl'
                                  className='stm-height-32 stm-width-auto' />
                            }
                          </div>
                          <div className='stm-width-20-percent stm-padding-8'>{item.taskName}</div>
                          <div className='stm-width-10-percent stm-padding-8'>{item.stayPleaseTaskID}</div>
                          <div className='stm-width-10-percent stm-padding-8'>{item.isShown ? t('Yes') : t('No')}</div>
                          <div className='stm-width-10-percent stm-padding-8'>{item.isSoon ? t('Yes') : t('No')}</div>
                          <div className='stm-width-10-percent stm-padding-8'>{item.sortID}</div>
                          <div className='stm-width-15-percent stm-padding-8'>
                            <>
                              {
                                !selectedData
                                  ?
                                  <>
                                    <Button
                                      type={item.isShown ? 'primary' : 'default'}
                                      className='stm-font-size-16 stm-line-height-20 stm-width-100 stm-height-32 stm-margin-right-16'
                                      onClick={() => this.props.CmsMenuStore.edit(item.taskID)}>{t('Edit')}</Button>
                                    {
                                      item.isShown
                                        ?
                                        <>
                                          <Button
                                            type='default'
                                            className='stm-font-size-16 stm-line-height-20 stm-width-100 stm-height-32'
                                            onClick={() => this.disabled(item.taskID)}>{t('Disabled')}</Button>
                                        </>
                                        :
                                        <Button
                                          type='default'
                                          className='stm-font-size-16 stm-line-height-20 stm-width-100 stm-height-32'
                                          onClick={() => this.enabled(item.taskID)}>{t('Enabled')}</Button>
                                    }
                                  </>
                                  :
                                  null
                              }
                            </>
                          </div>
                        </div>
                        <>
                          {
                            selectedData && item.taskID === selectedData.taskID
                              ?
                              <>
                                <div className='stm-font-size-14 stm-line-height-18 
                                                stm-color-495057 
                                                stm-border-style-solid 
                                                stm-border-width-1 
                                                stm-border-color-white-two 
                                                stm-border-radius-4 
                                                stm-padding-16'>
                                  <div className='stm-font-size-18 stm-line-height-20 stm-font-weight-bold stm-margin-bottom-16'>{t('Update Menu')}</div>
                                  <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-16'>
                                    <div className='stm-width-15-percent'>{t('Module')}</div>
                                    <div className=''>
                                      <Select
                                        value={selectedData.menuType}
                                        onChange={(value) => this.props.CmsMenuStore.setmenuType(value)}
                                        className='stm-width-266'>
                                        {
                                          menuTypes.map(menuType => {
                                            return (<Option key={menuType.value} value={menuType.value}>{menuType.label}</Option>)
                                          })
                                        }
                                      </Select>
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-16'>
                                    <div className='stm-width-15-percent'>{t('Name')}</div>
                                    <div className='stm-font-weight-bold'>{selectedData.taskName}</div>
                                  </div>
                                  <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Icon')}</div>
                                    <div className=''>
                                      <Upload
                                        listType='picture-card'
                                        className='avatar-uploader stm-min-width-100'
                                        showUploadList={false}
                                        customRequest={this.dummyIconRequest}
                                        beforeUpload={this.beforeUploadIconImage}
                                        onChange={(info) => this.uploadChangeIconImage(info, 'MenuIcon')}
                                      >
                                        {
                                          selectedData.imageUrl !== ''
                                            ?
                                            <img src={selectedData.imageUrl} alt='avatar' className='stm-height-32 stm-width-auto' />
                                            :
                                            <div>
                                              <Icon style={{ color: '#32323F' }} type={this.state.uploadingIconImage ? 'loading' : 'plus'} />
                                              <div className='stm-font-size-14 stm-line-height-18 stm-color-495057'>{t('Upload')}</div>
                                            </div>
                                        }
                                      </Upload>
                                      <div className='stm-font-size-12 stm-line-height-16 stm-margin-bottom-8'>{t('Note: Supports only JPG, PNG, and SVG File. Recommendation: 40 x 40. Maximum Size is 1MB.')}</div>
                                      <>
                                        {
                                          selectedData.imageUrl !== ''
                                            ?
                                            <div className='stm-margin-bottom-10'>
                                              <Button type='danger'
                                                className='stm-font-size-14 stm-line-height-20 stm-width-150'
                                                onClick={() => this.props.CmsMenuStore.setimageUrl('')}>{t('Delete Icon')}</Button>
                                            </div>
                                            :
                                            null
                                        }
                                      </>
                                      <>
                                        {
                                          selectedData.menuType !== ''
                                            ?
                                            <div className='stm-margin-bottom-10'>
                                              <Button type='primary'
                                                className='stm-font-size-14 stm-line-height-20 stm-width-150'
                                                onClick={() => this.props.CmsMenuStore.setDefaultImageUrl(selectedData.menuType)}>{t('Use Default Icon')}</Button>
                                            </div>
                                            :
                                            null
                                        }
                                      </>
                                    </div>
                                  </div>

                                  {/* Banner */}
                                  <>
                                    <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-8'>
                                      <div className='stm-width-15-percent'>{t('Banner')}</div>
                                      <div className=''>
                                        <Upload
                                          listType='picture-card'
                                          className='avatar-uploader stm-min-width-100'
                                          showUploadList={false}
                                          customRequest={this.dummyBannerRequest}
                                          beforeUpload={this.beforeUploadBannerImage}
                                          onChange={(info) => this.uploadChangeBannerImage(info, 'MenuBanner')}
                                        >
                                          {
                                            selectedData.bannerUrl !== '' && selectedData.bannerUrl !== null
                                              ?
                                              <img src={selectedData.bannerUrl} alt='avatar' className='stm-height-100 stm-width-auto' />
                                              :
                                              <div>
                                                <Icon style={{ color: '#32323F' }} type={this.state.uploadingBannerImage ? 'loading' : 'plus'} />
                                                <div className='stm-font-size-14 stm-line-height-18 stm-color-495057'>{t('Upload')}</div>
                                              </div>
                                          }
                                        </Upload>
                                        <div className='stm-font-size-12 stm-line-height-16 stm-margin-bottom-8'>{t('Note: Supports only JPG, PNG, and SVG File. Recommendation: 400 x 160. Maximum Size is 1MB.')}</div>
                                        <>
                                          {
                                            selectedData.bannerUrl !== ''
                                              ?
                                              <div className='stm-margin-bottom-10'>
                                                <Button type='danger'
                                                  className='stm-font-size-14 stm-line-height-20 stm-width-150'
                                                  onClick={() => this.props.CmsMenuStore.setbannerUrl('')}>{t('Delete Banner')}</Button>
                                              </div>
                                              :
                                              null
                                          }
                                        </>
                                        <>
                                          {
                                            selectedData.menuType !== ''
                                              ?
                                              <div className='stm-margin-bottom-10'>
                                                <Button type='primary'
                                                  className='stm-font-size-14 stm-line-height-20 stm-width-150'
                                                  onClick={() => this.props.CmsMenuStore.setDefaultBanner(selectedData.menuType)}>{t('Use Default Banner')}</Button>
                                              </div>
                                              :
                                              null
                                          }
                                        </>
                                      </div>
                                    </div>
                                  </>
                                  {/* StayPlease Task ID - 除了 IN_ROOM_DINING_URL 都显示 */}
                                  {
                                    selectedData.menuType !== 'IN_ROOM_DINING_URL' && (
                                      <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-8'>
                                        <div className='stm-width-15-percent'>{t('StayPlease Task ID')}</div>
                                        <div className=''>
                                          <InputNumber
                                            min={0}
                                            value={selectedData.stayPleaseTaskID}
                                            onChange={(value) => this.props.CmsMenuStore.setstayPleaseTaskID(value)}
                                            className='stm-margin-bottom-4' />
                                          <div className='stm-font-size-12 stm-line-height-16'>{t('Note: This is for place order purpose. Please Ask Tommy for the value.')}</div>
                                        </div>
                                      </div>
                                    )
                                  }
                                  {/* Redirect URL - 仅在 IN_ROOM_DINING_URL 时显示 */}
                                  {
                                    selectedData.menuType === 'IN_ROOM_DINING_URL' && (
                                      <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-8'>
                                        <div className='stm-width-15-percent'>{t('Redirect URL')}</div>
                                        <div className=''>
                                          <Input
                                            value={selectedData.redirectUrl || ''}
                                            onChange={(e) => this.props.CmsMenuStore.setredirectUrl(e.target.value)}
                                            placeholder='https://example.com/order'
                                            className='stm-width-266 stm-margin-bottom-4' />
                                          <div className='stm-font-size-12 stm-line-height-16'>{t('Note: Enter the full URL including http:// or https://')}</div>
                                        </div>
                                      </div>
                                    )
                                  }
                                  <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Is Available')}</div>
                                    <div className=''>
                                      <Switch
                                        checkedChildren={t('Yes')}
                                        unCheckedChildren={t('No')}
                                        checked={selectedData.isShown}
                                        onChange={(value) => this.props.CmsMenuStore.setisShown(value)} />
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Hide (Soon)')}</div>
                                    <div className=''>
                                      <Switch
                                        checkedChildren={t('Yes')}
                                        unCheckedChildren={t('No')}
                                        checked={selectedData.isSoon}
                                        onChange={(value) => this.props.CmsMenuStore.setisSoon(value)} />
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Sort')}</div>
                                    <div className=''>
                                      <InputNumber
                                        min={0}
                                        value={selectedData.sortID}
                                        onChange={(value) => this.props.CmsMenuStore.setsortID(value)} />
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('VAT')}</div>
                                    <div className=''>
                                      <InputNumber
                                        min={0}
                                        value={selectedData.vat}
                                        onChange={(value) => this.props.CmsMenuStore.setvat(value)} />
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Service Fee')}</div>
                                    <div className=''>
                                      <InputNumber
                                        min={0}
                                        value={selectedData.serviceFee}
                                        onChange={(value) => this.props.CmsMenuStore.setserviceFee(value)} />
                                    </div>
                                  </div>
                                  <div className='smt-margin-top-36'>
                                    <Button
                                      type='primary'
                                      className='stm-font-size-16 stm-line-height-20 stm-width-100 stm-height-32 stm-margin-right-8'
                                      onClick={this.update}>{t('Update')}</Button>
                                    <Button
                                      type='default'
                                      className='stm-font-size-16 stm-line-height-20 stm-width-100 stm-height-32'
                                      onClick={() => this.props.CmsMenuStore.cancelUpdate()}>{t('Cancel')}</Button>
                                  </div>
                                </div>
                              </>
                              :
                              null
                          }
                        </>
                      </>
                    )
                  })
                }
              </>
            </Form.Item>
          </Grid>
        </Grid>
      </MainContainer>
    )
  }
}

export default withTranslation(undefined, { i18n: adminI18n })(CmsMenu);